<template>
  <v-app>
    <div id="maverick">
      <div id="desktopview">
        <template v-if="initState === 1">
          <v-app v-if="$store.state.app.loadTheme">
            <left-menu></left-menu>
            <top></top>
            <back-top></back-top>
            <v-main>
              <v-container fluid fill-height v-scroll="onScroll" id="mavContainer" class="pa-9">
                <!-- Transition css from vuetify -->
                <transition name="slide-x-transition" mode="out-in">
                  <router-view :key="routeKey"></router-view>
                </transition>
                <search></search>
                <div v-if="rptProcess.show" class="processSpacer"></div>
                <rpt-process></rpt-process>
              </v-container>
              <v-snackbar
                v-model="bchProcess.show"
                top
                right
                :timeout="snackbarTimeout"
                :color="bchProcess.snackbarColor"
                class="pt-12"
              >
                {{ bchProcess.bchMsg }}
                <template v-slot:action="{ attrs }">
                  <v-btn
                    text
                    v-bind="attrs"
                    @click="bchProcess.show = false"
                  >
                    Close
                  </v-btn>
                </template>
              </v-snackbar>
            </v-main>
            <bottom></bottom>
          </v-app>
          <v-app v-else>
            <v-main>
              <v-container fluid fill-height v-scroll="onScroll" id="mavContainer" class="emptyContainer">
                <transition name="slide-x-transition" mode="out-in">
                  <router-view :key="routeKey"></router-view>
                </transition>
              </v-container>
            </v-main>
          </v-app>
          <v-dialog v-model="$store.state.user.sessionExpired" persistent max-width="290">
            <v-card>
              <v-card-title class="headline">Session Expired</v-card-title>
              <v-card-text>Your session has expired. Please login again to renew your session.</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click.native="doReload">{{ 'Reload Application (' + timeLeft +  ')' }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="showBranchDialog" persistent max-width="480" width="420">
            <default-branch @close="showBranchDialog = false" @continueLogin="doContinueLogin"></default-branch>
          </v-dialog>
        </template>
        <template v-else>
          <splash-page></splash-page>
        </template>
      </div>
      <div id="mobileview">
        <template>
          <v-card class="mx-auto" color="#009688" dark max-width="450" height="850">
            <v-card-title class="text-h2 font-weight-black"> To Access Odyssey 5, you need one of the following devices: </v-card-title>
            <br />
            <v-card-title class="text-h2 font-weight-black"> Desktop, Laptop, and Tablet </v-card-title>
            <v-card-actions>
              <v-flex xs12>
                <v-img class="elevation-6" alt="" src="/static/img/tri.png"></v-img>
              </v-flex>
            </v-card-actions>
            <br />
          </v-card>
          <br />
          <br />
          <br />
        </template>
      </div>
      <vue-snotify></vue-snotify>
      <DownloadBtn></DownloadBtn>
      <back-top :showButton="showBackTop"></back-top>
    </div>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
import LeftMenu from '@/components/template/LeftMenu'
import Top from '@/components/template/Top'
import Bottom from '@/components/template/Bottom'
import BackTop from '@/components/template/BackTop'
import SplashPage from '@/components/misc/SplashPage'
import Search from '@/components/misc/search/Search'
import RptProcess from '@/components/template/RptProcess'
import DefaultBranch from '@/components/core/common/dialog/DefaultBranch'
import { USER_DEFAULT_BRANCH } from '@/store/types'
import DownloadBtn from './components/template/DownloadBtn.vue'

export default {
  name: 'app',
  data: () => ({
    showBackTop: false,
    snackbarTimeout: 60000,
    timeLeft: 3
  }),
  computed: {
    showBranchDialog() {
      // AR 28-Jun-2019: Added for selecting user branch after logged in
      return (
        (this.$store.state.app.wsLink === 'ws' || this.$store.state.app.wsLink === null) &&
        this.$store.getters.userInitials !== '--' &&
        (this.$store.state.token.userBranch === '' || this.$store.state.token.userBranch === undefined)
      )
    },
    initState() {
      return this.$store.state.app.init
    },
    routeKey() {
      if (this.$route.matched && this.$route.matched.length > 0) {
        // This is to solve the route loading fail for pages with same component
        // Eg: SubRoute - Vue JS will reuse same component for same route level, thus not triggering the lifeCycle methods
        // Note: this will only solve the problem for index 0 route
        return this.$route.matched[0].name
      }
      return ''
    },
    rptProcess() {
      return this.$store.state.user.rptJob.rptProcess
    },
    bchProcess() {
      return this.$store.state.user.bchJob.bchProcess
    }
  },
  methods: {
    ...mapActions(['appInit']),
    onScroll(e) {
      // Scroll listener for back-to-top button
      const offset = window.pageYOffset || document.documentElement.scrollTop
      if (offset && offset > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }
    },
    doReload() {
      window.location.reload()
    },
    // AR 28-Jun-2019: Added for selecting user branch after logged in
    doContinueLogin(selectedBranch) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.commit(USER_DEFAULT_BRANCH, selectedBranch)
        }
      })
    }
  },
  mounted() {
    this.appInit()
    // Remove Web Notification 1st, IE 11 seems to have some problems
    // Request for permission to send Browser Notification
    // Notification.requestPermission().then(function (result) {
    // })
  },
  watch: {
    '$store.state.user.sessionExpired': function (value) {
      if (value) {
        this.timeLeft = 3
        setInterval(() => {
          if (this.timeLeft > 0) {
            this.timeLeft--
          } else {
            this.doReload()
          }
        }, 1000)
      }
    }
  },
  components: {
    LeftMenu,
    Top,
    Bottom,
    BackTop,
    SplashPage,
    Search,
    RptProcess,
    DefaultBranch,
    DownloadBtn
  }
}
</script>

<style lang="scss">
@import '~roboto-fontface/css/roboto/roboto-fontface.css';
@import '~vue-snotify/styles/material';
@import '~mdi/css/materialdesignicons.min.css';
@import '~vuetify/dist/vuetify.min.css';
@import '~hopscotch/dist/css/hopscotch.min.css';
@import './assets/scss/override.scss';
@import './assets/scss/index.scss';

#maverick {
  width: 100%;
  height: 100%;
  #mavContainer {
    &.emptyContainer {
      padding: 0px !important;
    }
    align-items: flex-start !important;
  }
  .processSpacer {
    // Spacer to fill up when rptJob Process is shown
    min-height: 30px;
  }

  // Bug in either cssnano or vuetify that v-divider is not showing
  .v-divider {
    border-style: solid !important;
  }

  #mobileview {
    display: none;
  }

  #desktopview {
    display: block;
  }

  @media (max-width: 480px) {
    /* smartphones, Android phones, landscape iPhone */
    #mobileview {
      display: block;
    }

    #desktopview {
      display: none;
    }
  }
}
</style>
